<template>
  <button
    class="relative inline-flex items-center justify-center rounded-full bg-primary/8 px-3 py-1 font-medium text-primary hover:bg-primary/15 focus:z-10 focus:outline-none disabled:pointer-events-none disabled:opacity-40"
    type="button"
    :disabled="isLoading"
  >
    <slot />
    <BaseInnerLoading v-if="isLoading" />
  </button>
</template>

<script setup lang="ts">
defineProps<{
  isLoading?: boolean
}>()
</script>
